// JSA Confined Space Validation

// Since Confined Space is not a requirement to be completed when a user is filling out a DEL, however it does have time and date fields that need to be validated if the user has input in them.
export const validateJsaConfinedSpace = (jsaConfinedSpace) => {
  const errors = [];

  // Checking if the time and date fields are empty
  const militaryTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  if (
    jsaConfinedSpace.cseAdminNotificationTime &&
    jsaConfinedSpace.cseAdminNotificationTime !== ""
  ) {
    if (!militaryTimeRegex.test(jsaConfinedSpace.cseAdminNotificationTime)) {
      errors.push("Confined space time is not valid");
    }
  }

  // Checking if the date field is empty
  const yyyymmddRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  console.log(
    "CSE Admin Notification Date:",
    jsaConfinedSpace.cseAdminNotificationDate
  );
  if (
    jsaConfinedSpace.cseAdminNotificationDate &&
    jsaConfinedSpace.cseAdminNotificationDate !== ""
  ) {
    if (!yyyymmddRegex.test(jsaConfinedSpace.cseAdminNotificationDate)) {
      errors.push("Confined space date is not valid");
    }
  }

  return errors;
};
